const state = {
  listCategory: [],
  listCountry: [],
  listCity: [],
  listNeighborhood: [],
  listLevelExprerience: [],
  jobDetail: {},
  jobDetailNew: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/post-a-job/state.js